import React from 'react';
import { useTvPlayback } from '../../../../hooks/useTvPlayback';
import type { TvConfig } from '../../../../utils/tvConfig';
import { UNPAIRED_MESSAGE, type TvPlaybackStatus } from '../../../../utils/tvPlayback';
import { TvSlide } from '../TvSlide';

interface TvPlayerProps {
  config: TvConfig;
}

const FRAME_MESSAGES: Partial<Record<TvPlaybackStatus, string>> = {
  loading: 'Loading memories…',
  empty: 'No photos yet.',
  unpaired: UNPAIRED_MESSAGE,
  parked: 'Paused.',
};
const SLIDES_VISIBLE: readonly TvPlaybackStatus[] = ['playing'];

export const TvPlayer: React.FC<TvPlayerProps> = ({ config }) => {
  const { status, layers, active } = useTvPlayback(config);
  const message = FRAME_MESSAGES[status];

  return (
    <div className="tv-slideshow">
      {SLIDES_VISIBLE.includes(status) && layers.map((layer, i) => (
        <TvSlide
          key={i}
          layer={layer}
          active={active === i}
          fill={config.fill}
          showCaption={config.showCaption}
        />
      ))}
      {message && <div className="tv-slideshow__message">{message}</div>}
    </div>
  );
};
